module.exports = __webpack_public_path__ + "img/lordsmobile.87d2cd6.jpg";